import { ReactNode } from 'react';

import AccordianContent from './AccordianContent';
import AccordianProvider from './context';

export interface AccordianItem {
  id: string;
  button: ReactNode;
  content: ReactNode;
  wrapperClassName?: string;
}

export interface AccordianProps {
  items: AccordianItem[];
  milliseconds?: number;
  accordianClassName?: string;
}

const Accordian: React.FunctionComponent<AccordianProps> = function (props) {
  return (
    <AccordianProvider {...props}>
      <AccordianContent />
    </AccordianProvider>
  );
};

export default Accordian;
